import { PathRecord } from "../../model/analytics/PathRecord.js";
import { requestJson } from "../../../packages/fetcher/fetcherFunctions.js";

/**
 * Retrieves entries.
 */
export const getAnalyticsFiles = async () => {
  return requestJson<string[], undefined>(`/api/analytics/files`, "GET", undefined);
};

/**
 * Retrieves statistics.
 */
export const getPathRecords = async (file: string) => {
  return requestJson<PathRecord[], undefined>(
    `/api/analytics/files/${encodeURIComponent(file)}`,
    "GET",
    undefined
  );
};
